import { useEffect, useState } from 'react';
import useWindowWidth from '../../../hooks/useWindowWidth';
import Icon from '../../Atoms/Icon/Icon';
import bem from '../../../utils/bem';
import DisplaySwitcher from '../../Molecules/DisplaySwitcher';
import SortBy from '../../Molecules/SortBy';

const ListingMeta = ({
  pagedItems,
  totalResults,
  displaySwitcherState,
  setDisplaySwitcherState,
  sortByState,
  sortByOptions,
  setSortByState,
  setFiltersActive,
  filtersState,
  setFiltersState,
  showingResultsCountText,
  showResults = true,
  bottomSort = false,
  showSelectedSort = false,
  displaySwitcherView,
  toggleData,
  displaySwitcherMobileHidden,
  showAppliedFilters = true,
  showFiltersText,
  showFiltersAnalytic,
}) => {
  const metaBaseClass = 'listing-meta';
  const [appliedFilters, setAppliedFilters] = useState(0);
  const { width } = useWindowWidth();
  useEffect(() => {
    if (filtersState) {
      let filterValues = 0;
      Object.values(filtersState).forEach((filterValue) => {
        if (Array.isArray(filterValue) && filterValue.length) {
          filterValues += filterValue.length;
        }
      });

      setAppliedFilters(filterValues);
    }
  }, [filtersState]);
  const facetNames = window.drupalSettings.algoliaSearch.facet.facetKey;
  const removeFilter = (value, filter) => {
    setFiltersState((prev) => {
      return {
        ...prev,
        [filter]: prev[`${filter}`].filter((v) => value !== v),
      };
    });
  };

  const filters = () => {
    if (!appliedFilters) {
      return '';
    }

    return (
      <div
        className={bem('applied-filters', [], metaBaseClass, [
          'hidden',
          'flex-wrap',
        ])}
      >
        {Object.entries(filtersState).map(([filter, filterValue]) => {
          if (Array.isArray(filterValue) && facetNames.indexOf(filter) > -1) {
            return filterValue.map((value) => {
              return (
                <div
                  key={`filter-${filter}-${value}`}
                  className={bem('filter-tag', [], metaBaseClass)}
                >
                  {value}
                  <button
                    className="btn-icon"
                    onClick={() => removeFilter(value, filter)}
                  >
                    <span className="visually-hidden">
                      {Drupal.t('Remove')}
                    </span>
                    <Icon iconName="close-thin" />
                  </button>
                </div>
              );
            });
          }
          return '';
        })}
      </div>
    );
  };

  return (
    <div
      className={bem(
        metaBaseClass,
        [bottomSort && 'bottom-sort', displaySwitcherView],
        '',
        ['flex', 'justify-between'],
      )}
    >
      {!displaySwitcherState && !sortByState && width && filtersState < 480 ? (
        <button
          className={`${metaBaseClass}__filters-button btn btn--secondary ml-auto`}
          onClick={() => {
            setFiltersActive(true);
            // Analytics for showing filters.
            if (typeof showFiltersAnalytic === 'function') {
              showFiltersAnalytic();
            }
          }}
        >
          {Drupal.t('SHOW FILTERS')}{' '}
          {appliedFilters && showAppliedFilters ? `(${appliedFilters})` : ''}
        </button>
      ) : (
        ''
      )}
      {showResults ? (
        <div className={bem('results-meta', [], metaBaseClass)}>
          {<b>{showingResultsCountText || Drupal.t('Results')}:</b>}{' '}
          {`${pagedItems || 0} of ${totalResults || 0}`}
        </div>
      ) : (
        ''
      )}

      <div
        className={bem('controls', [], metaBaseClass, ['flex', 'items-center'])}
      >
        {sortByState && (
          <SortBy
            sortByState={sortByState}
            setSortByState={setSortByState}
            sortByOptions={sortByOptions}
            showSelected={showSelectedSort}
          />
        )}

        {displaySwitcherState && (
          <DisplaySwitcher
            displaySwitcherState={displaySwitcherState}
            setDisplaySwitcherState={setDisplaySwitcherState}
            displaySwitcherView={displaySwitcherView}
            toggleData={toggleData}
            mobileHidden={displaySwitcherMobileHidden}
          />
        )}

        {typeof setFiltersActive === 'function' && filtersState && (
          <button
            className={`${metaBaseClass}__filters-button btn btn--m btn--secondary`}
            onClick={() => {
              setFiltersActive(true);
              // Analytics for showing filters.
              if (typeof showFiltersAnalytic === 'function') {
                showFiltersAnalytic();
              }
            }}
          >
            {Drupal.t(showFiltersText || 'SHOW FILTERS')}{' '}
            {appliedFilters && showAppliedFilters ? `(${appliedFilters})` : ''}
          </button>
        )}
      </div>
      {showAppliedFilters && filters()}
    </div>
  );
};

export default ListingMeta;
